// #ux-redesign-start: InboxViewDetail — copia 1:1 del de Doctors.
// Layout flex column:
//   - header (subject + from + to + date) → fijo arriba
//   - files  (chips) → entre header y body, visible al instante
//   - body   → scroll cuando rebalsa
//   - thread → debajo del body, dentro del mismo scroll
// HTML del WYSIWYG renderizado con sanitizeMessageHtml. Texto plano legacy
// preserva \n con <br/>.
// ─────────────────────────────────────────────────────────────────────────────
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Button } from 'reactstrap';
import moment from 'moment';
import { useTranslate } from 'react-translate';

import { LoadingBlock } from 'components/ds';
import InboxFileList from 'components/Messages/View/InboxFileList';
import { actionSetSelectedMessages } from 'store/actions/messagesActions';
import { sanitizeMessageHtml } from 'helpers/sanitizeMessage';

const InboxViewDetail = () => {
  const t = useTranslate('messages');
  const t2 = useTranslate('inbox-mobile-detail');
  const dispatch = useDispatch();
  const [limit, setLimit] = useState(1);

  const { message, loading_msg, box } = useSelector(
    (state) => state.messagesReducer
  );

  useEffect(() => {
    if (message && !window.location.href.includes('reply')) {
      dispatch(actionSetSelectedMessages([message._id]));
    }
  }, [loading_msg, message, dispatch]);

  if (loading_msg) {
    return <LoadingBlock />;
  }

  if (!loading_msg && !message) {
    return (
      <div className="p-5">
        <Alert color="info">{t2('select-a-message')}</Alert>
      </div>
    );
  }

  const files = Array.isArray(message?.files) ? message.files : [];

  const isHtmlBody = (text) =>
    typeof text === 'string' && /<[a-z][\s\S]*>/i.test(text);

  const formatText = (text) => {
    if (!text) return null;
    if (isHtmlBody(text)) {
      return (
        <span
          className="ds-msg-html"
          dangerouslySetInnerHTML={{ __html: sanitizeMessageHtml(text) }}
        />
      );
    }
    return text.split('\n').map((item, i) => (
      <React.Fragment key={i}>
        {item}
        <br />
      </React.Fragment>
    ));
  };

  return (
    <div className="inbox-view-detail">
      <header className="inbox-view-detail-header">
        <div className="inbox-message-subject">
          <strong>{t('subject')}: </strong>
          {message.subject}
        </div>
        <div className="inbox-message-from">
          <div>
            <strong>{t('from')}: </strong>
            {message?.from.firstName} {message?.from.lastName}
          </div>
          {box === 'outbox' && message.to && (
            <div>
              <strong>{t('to')}: </strong>
              {message.to.map(
                (user_to, i) =>
                  `${user_to.firstName} ${user_to.lastName}${
                    i + 1 !== message.to.length ? ', ' : ''
                  }`
              )}
            </div>
          )}
          <div className="message-date">
            <strong>{t('date')}: </strong>
            {moment(message?.date).format('L HH:mm')}
          </div>
        </div>
        {message.priority ? (
          <div>
            <strong>{t('important')}</strong>
          </div>
        ) : null}
      </header>

      {files.length > 0 && (
        <section
          className="inbox-view-detail-attachments"
          aria-label={t('attachments') || 'Attachments'}
        >
          <InboxFileList files={files} />
        </section>
      )}

      <section className="inbox-view-detail-body">
        <div className="inbox-message-text">
          <p className="text-justify">{formatText(message?.body)}</p>
        </div>

        {message.thread
          ?.slice(limit * -1)
          .reverse()
          .map((th) => (
            <div key={th.date} className="message-reply">
              <div className="thread-message-header">
                <span>
                  {th.from.firstName} {th.from.lastName}
                </span>
                <span className="message-date ml-5">
                  {`${moment(th.date).format('D MMM YYYY HH:mm')} (${moment(
                    th.date
                  ).fromNow()})`}
                </span>
              </div>
              {Array.isArray(th.files) && th.files.length > 0 && (
                <div className="message-reply__attachments">
                  <InboxFileList files={th.files} />
                </div>
              )}
              <p className="text-justify">{formatText(th?.body)}</p>
            </div>
          ))}

        {limit < (message.thread?.length || 0) && (
          <div className="inbox-detail-thread-loadmore">
            <div className="inbox-detail-thread-counter">
              {message.thread?.length - limit}
            </div>
            <Button
              type="button"
              size="sm"
              color="info"
              onClick={(e) => {
                e.preventDefault();
                setLimit(limit + 5);
              }}
            >
              Load{' '}
              {message.thread?.length - limit > 5
                ? '5'
                : message.thread?.length - limit}{' '}
              messages
            </Button>
          </div>
        )}
      </section>
    </div>
  );
};

export default InboxViewDetail;
// #ux-redesign-end
